import { useLocation } from 'react-router-dom';
import { CommonQueryParams } from '../models/common-query-params';

export function useQuery<T = CommonQueryParams>() {
  return new URLSearchParams(useLocation<T>().search);
}
